import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  AfterViewChecked
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: "app-filtro-validade",
  templateUrl: "filtro-validade.component.html",
  styleUrls: ["./filtro-validade.component.scss"],
})
export class FiltroValidadeComponent implements OnInit {
  @Output() onFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClear: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpen: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPageUpdate: EventEmitter<number> = new EventEmitter<number>();

  @Input() resetFilter: boolean;
  @Input() filtroAtivo: any;
  @Input() visible: string;

  searchForm: FormGroup;
  validades = [];
  validade = "Situação";
  validadeSelecionada: string = null;
  validadeDescricao: string = null;
  obj: {
    a_vencer: boolean;
    vencidos: boolean;
    respostaAVencer: boolean;
    respostasVencidas: boolean;
    respondidas: boolean;
  };

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.criarFormulario();
    this.montarValidades();
  }

  criarFormulario() {
    this.searchForm = this.fb.group({
      validadeSelecionada: [null],
    });
  }

  montarValidades() {
    this.validades = [
      {
        descricao: 'Com Prazo da ciência a vencer',
        id: 'a_vencer'
      },
      {
        descricao: 'Com Prazo vencido de ciência',
        id: 'vencidos'
      },
      {
        descricao: 'Com Prazo para a resposta vencer',
        id: 'respostaAVencer'
      },
      {
        descricao: 'Com Prazo vencido para resposta',
        id: 'respostasVencidas'
      },
    ]
  }

  validadeFilter(event, descricao) {
    this.validadeDescricao = descricao;
    this.validadeSelecionada = event.target.id;
  }

  limparFiltros() {
    this.obj = {
      a_vencer: false,
      vencidos: false,
      respostaAVencer: false,
      respostasVencidas: false,
      respondidas: false
    };
    
    this.onClear.emit(this.obj);
    this.validade = "Situação";
    this.filtroAtivo = false;
    this.validadeSelecionada = null;
    this.onClear.emit('validade');

    this.onFilter.emit(this.obj);
    this.onPageUpdate.emit(1);
  }

  getValidadeResumida(descricao: string): string {
    if (descricao.includes('Prazo da ciência a vencer')) {
      return 'Ciência a vencer';
    } else if (descricao.includes('Prazo vencido de ciência')) {
      return 'Ciência vencida';
    } else if (descricao.includes('Prazo para a resposta vencer')) {
      return 'Resposta a vencer';
    } else if (descricao.includes('Prazo vencido para resposta')) {
      return 'Resposta vencida';
    }
    return descricao;
  }

  pesquisarValidade() {
    this.validade = this.getValidadeResumida(this.validadeDescricao);
    this.obj = {
      a_vencer: false,
      vencidos: false,
      respostaAVencer: false,
      respostasVencidas: false,
      respondidas: false,
    };

    switch (this.validadeSelecionada) {
      case "a_vencer": {
        this.obj["a_vencer"] = true;
        break;
      }
      case "vencidos": {
        this.obj["vencidos"] = true;
        break;
      }
      case "respostaAVencer": {
        this.obj["respostaAVencer"] = true;
        break;
      }
      case "respostasVencidas": {
        this.obj["respostasVencidas"] = true;
        break;
      }
    }

    this.onFilter.emit(this.obj);
    this.filtroAtivo = true;

    this.onFilter.emit(this.obj);
    this.onPageUpdate.emit(1);
  }

  resetarParametros() {
    this.obj = {
      a_vencer: false,
      vencidos: false,
      respostaAVencer: false,
      respostasVencidas: false,
      respondidas: false
    };

    this.validadeSelecionada = null;
    this.filtroAtivo = false;
    this.validade = "Situação";
  }
}
